import React from "react";
import styled from "styled-components";

const Wrapper = styled.svg`
  width: auto;
  height: 2.75rem;
`;
export default function Chaudiere() {
  return (
    <Wrapper
      width="362"
      height="512"
      viewBox="0 0 362 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M302 0H60C26.9141 0 0 26.9141 0 60V392C0 425.086 26.9141 452 60 452H108V512H148V452H212V512H252V452H302C335.086 452 362 425.086 362 392V60C362 26.9141 335.086 0 302 0ZM60 40H302C313.027 40 322 48.9727 322 60V326.129C292.562 316.871 236.742 302 182 302C127.852 302 70.7695 316.559 40 325.797V60C40 48.9727 48.9727 40 60 40ZM302 412H60C48.9727 412 40 403.027 40 392V367.723C63.0742 360.285 125.562 342 182 342C239.949 342 301.684 361.313 322 368.254V392C322 403.027 313.027 412 302 412ZM120.5 210.801H80.5C80.5 155.266 125.586 110.082 181 110.082C236.414 110.082 281.5 155.266 281.5 210.801H241.5C241.5 196.461 236.508 183.273 228.195 172.871L204.754 210.801H157.73L194.328 151.586C190.035 150.613 185.578 150.082 181 150.082C147.641 150.082 120.5 177.32 120.5 210.801Z"
        className="fill"
      />
    </Wrapper>
  );
}
